/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import { componentsMetadata as searchComponentsMetadata } from "./search";

/**
 * Components metadata.
 */
const componentsMetadata = [searchComponentsMetadata];

/**
 * Prepare metadata from the components defined in the module.
 * For each component, what it will override in the Invenio interface
 * is defined together with the component itself.
 * @returns {*}
 */
export const loadModuleMetadata = () => {
  return componentsMetadata.reduce((acc, item) => {
    acc = { ...acc, ...item };
    return acc;
  }, {});
};
